// Serialised GATT startNotifications with retry. Chrome rejects concurrent GATT
// operations ("GATT operation already in progress"), which silently killed the
// force-curve / stroke-power subscriptions when they raced pm5Connection's own.
let queue = Promise.resolve();

export function startNotificationsSafe(char, attempts = 5) {
  const run = async () => {
    for (let i = 0; i < attempts; i += 1) {
      try {
        await char.startNotifications();
        return true;
      } catch (e) {
        if (i === attempts - 1) throw e;
        await new Promise((r) => setTimeout(r, 400 * (i + 1)));
      }
    }
    return false;
  };
  const p = queue.then(run, run);
  queue = p.catch(() => {});
  return p;
}
